import { render, staticRenderFns } from "./CouponDialog.vue?vue&type=template&id=3312ea4d"
import script from "./CouponDialog.vue?vue&type=script&lang=js"
export * from "./CouponDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports